// =============================================================================
// Vacations API (art. 38 ET)
// =============================================================================
import { apiClient } from './http';

export interface VacationRequestItem {
  id: number;
  user_id: number;
  user_name?: string | null;
  start_date: string;
  end_date: string;
  days_natural: number;
  charge_year: number;
  status: 'PENDING' | 'APPROVED' | 'REJECTED' | 'CANCELLED';
  extension: string;
  approved_at: string | null;
  notice_ok: boolean | null;
  notes: string | null;
}

export interface VacationBalance {
  user_id: number;
  charge_year: number;
  entitled_days: number;
  used_days: number;
  available_days: number;
  expires_on: string | null;
}

export async function requestVacation(data: {
  start_date: string;
  end_date: string;
  notes?: string;
}): Promise<VacationRequestItem> {
  const response = await apiClient.post<VacationRequestItem>('/vacations', data);
  return response.data;
}

export async function getMyVacations(year?: number): Promise<VacationRequestItem[]> {
  const params = year ? `?year=${year}` : '';
  const response = await apiClient.get<VacationRequestItem[]>(`/vacations/mine${params}`);
  return response.data;
}

export async function getVacationBalance(userId: number, year: number): Promise<VacationBalance> {
  const response = await apiClient.get<VacationBalance>(`/vacations/balance/${userId}/${year}`);
  return response.data;
}

export async function getPendingVacations(): Promise<VacationRequestItem[]> {
  const response = await apiClient.get<VacationRequestItem[]>('/vacations/pending');
  return response.data;
}

export async function approveVacation(id: number): Promise<VacationRequestItem> {
  const response = await apiClient.post<VacationRequestItem>(`/vacations/${id}/approve`);
  return response.data;
}

export async function rejectVacation(id: number): Promise<VacationRequestItem> {
  const response = await apiClient.post<VacationRequestItem>(`/vacations/${id}/reject`);
  return response.data;
}

export async function cancelVacation(id: number): Promise<VacationRequestItem> {
  const response = await apiClient.post<VacationRequestItem>(`/vacations/${id}/cancel`);
  return response.data;
}

export interface TeamCalendarDay {
  date: string;
  absent: { user_id: number; user_name: string; request_id: number; until: string }[];
  worksites: {
    worksite_id: number;
    worksite_name: string | null;
    planned: number;
    absent: number;
    available: number;
    min_staff: number | null;
    below_min_staff: boolean;
  }[];
}

export async function getTeamCalendar(start: string, end: string): Promise<TeamCalendarDay[]> {
  const response = await apiClient.get<TeamCalendarDay[]>(
    `/vacations/team-calendar?start=${start}&end=${end}`
  );
  return response.data;
}
